<!-- @format -->

<template>
    <div class="gst-room-offer-fees">
        <!-- Fallback for other flows then Hotel Only - Open Inventory and Dynamic -->
        <template v-if="showFallback">
            <span
                v-if="bundleIncludesTaxesAndFees"
                class="gst-room-offer-fees__row">
                {{ $t('_common:terms.feesIncludedExcept', { amount: excludedText }) }}
            </span>
            <span
                v-else
                class="gst-room-offer-fees__row">
                {{ $t('_common:terms.excluded') }}: {{ excludedText }}
            </span>
        </template>

        <!-- Show for Hotel Only - Open Inventory and Dynamic  -->
        <template v-if="isOpenInventoryOrDynamicFlow && !redeemPointsToggle">
            <span
                v-if="totalIncluded"
                class="gst-room-offer-fees__row">
                {{ totalIncludedText }}
            </span>

            <span
                v-if="excluded.length"
                class="gst-room-offer-fees__row">
                {{ payLaterText }}
            </span>
        </template>

        <template v-if="excluded.length">
            <template v-if="redeemPointsToggle">
                <span class="gst-room-offer-fees__row">
                    {{ `${$t('_common:terms.excludesPayAtProperty')}: ${joinedFees}` }}
                </span>
            </template>

            <!-- Show for Manage My Booking flow  -->
            <template v-if="isManageBookingFlow">
                <span class="gst-room-offer-fees__row">
                    {{ `${$t('_common:terms.excludesPayAtProperty')}: ${joinedFees}` }}
                </span>
            </template>
        </template>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import roomRateFee from '@core/utils/constants/roomRateFee';
import { feesFilteredByIncludedType } from '@core/utils/feeUtils';
import EventFlowMixin from '@tenant/app/mixins/EventFlowMixin';

export default {
    name: 'RoomOfferFees',
    mixins: [EventFlowMixin],
    props: {
        allInclusivePricing: {
            type: Boolean || null,
            default: false,
        },
        bundleIncludesTaxesAndFees: {
            type: Boolean,
            default: false,
        },
        currency: {
            type: String,
            required: true,
        },
        fees: {
            type: Array,
            default: () => [],
        },
        totalIncluded: {
            type: Number || null,
            default: null,
        },
    },
    computed: {
        ...mapGetters({
            redeemPointsToggle: 'appState/getRedeemPointsToggle',
        }),
        totalIncludedFormatted() {
            return this.$options.filters.currencyFilter(this.totalIncluded, this.currency);
        },
        totalIncludedText() {
            return `${this.$t('_common:terms.includesTaxesAndFees')}: ${this.totalIncludedFormatted}`;
        },
        joinedFees() {
            return this.excluded
                .map((item) => this.$options.filters.roomRateFee(item.fee, this.currency))
                .join(` ${this.$t('_common:terms.and')} `);
        },
        payLaterText() {
            const textPrefix = this.allInclusivePricing
                ? this.$t('_common:terms.includesPayAtProperty')
                : this.$t('_common:terms.excludesPayAtProperty');

            return `${textPrefix}: ${this.joinedFees}`;
        },
        excludedText() {
            return this.excluded
                .map((item) => this.$options.filters.roomRateFee(item.fee, this.currency))
                .join(', ');
        },
        excluded() {
            return feesFilteredByIncludedType(this.fees, roomRateFee.TYPES_INCLUDED.PAY_LATER);
        },
        included() {
            return feesFilteredByIncludedType(this.fees, roomRateFee.TYPES_INCLUDED.INCLUDED);
        },
        showFallback() {
            return (
                !this.isOpenInventoryOrDynamicFlow &&
                !this.isManageBookingFlow &&
                this.excluded.length
            );
        },
    },
};
</script>
<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-room-offer-fees {
    .gst-room-offer-fees__row {
        display: block;
        line-height: normal;
        color: theme-color('tertiary');
        font-size: font-size('xxxxs');
        font-weight: font-weight('regular');
    }
}
</style>
